export var VcFindMyLocation = (function () {
    

    return {

      lookupLocation:function() {
        return new Promise((resolve, reject) => {

          
          fetch('https://api.ipdata.co/?api-key=2a3ba97e6c19d40545bdd9942b0d1cd06da89daeedadf02b3ed83929', {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache', 
            headers: {
            
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'strict-origin-when-cross-origin', 
          }).then(response => {
              if (!response.ok) {
                throw response;
              }
              
              return response.json();
          }).then(response => {

            var pieces=[];
            if (response.city) pieces.push(response.city);
            
            if (response.region_code) {
              pieces.push(response.region_code);
            } else if(response.region) {
              pieces.push(response.region);
            }
            if (response.country_code) {
              pieces.push(response.country_code);
            } else if(response.country_name) {
              pieces.push(response.country_name);
            }
            
            var address="";
            
            for (var i=0;i<pieces.length;i++) {
              if (address.length>0) address+=", ";
              address+=pieces[i];
            }

            resolve({
              lat:response.latitude,
              lon:response.longitude,
              address:address,
            });
          
          }).catch((errorResponse) => {
              if (errorResponse.text) {
                  errorResponse.text().then( errorMessage => {
                      reject(errorMessage);
                  })
              } else {
                  reject("An error occurred retrieving the data");
              }  
          });
        });
      },

      findMyLocation:function(useGps) {
        return new Promise((resolve, reject) => {
          if (useGps) {
            console.log("Finding location with GPS");
            
            // Check if geolocation is supported
            if (!navigator.geolocation) {
              console.log("Geolocation not supported");
              // Fallback to IP location
              return this.findMyLocation(false).then(resolve).catch(reject);
            }
            
            var options = {
              enableHighAccuracy: true,
              timeout: 10000, // Increased timeout for iOS
              maximumAge: 300000 // 5 minutes cache
            };
            
            navigator.geolocation.getCurrentPosition(function(pos) {
              pos = pos && pos.coords;
              if (!pos || !pos.latitude || !pos.longitude) {
                console.log("No position found");
                reject("Invalid GPS response");
                return;
              }
              resolve(pos.latitude.toFixed(4) + "," + pos.longitude.toFixed(4));
            }, 
            function(error) {
              console.log("Error retrieving GPS position:", error.code, error.message);
              
              // Handle specific GPS errors
              switch(error.code) {
                case error.PERMISSION_DENIED:
                  console.log("GPS permission denied, falling back to IP location");
                  break;
                case error.POSITION_UNAVAILABLE:
                  console.log("GPS position unavailable, falling back to IP location");
                  break;
                case error.TIMEOUT:
                  console.log("GPS timeout, falling back to IP location");
                  break;
                default:
                  console.log("Unknown GPS error, falling back to IP location");
                  break;
              }
              
              // Fallback to IP-based location
              this.findMyLocation(false)
                .then(response => {
                  resolve(response);
                })
                .catch(response => {
                  reject(response);
                });
            }.bind(this), options);
            
            return;
          }
          console.log("Finding location with computer location");
          fetch('https://api.ipdata.co/?api-key=2a3ba97e6c19d40545bdd9942b0d1cd06da89daeedadf02b3ed83929', {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache', 
            headers: {
            //'Content-Type': 'application/json'
            // 'Content-Type': contentType,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'strict-origin-when-cross-origin', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            //body: JSON.stringify(postdata) // body data type must match "Content-Type" header
            // body: data
          }).then(response => {
              if (!response.ok) {
                throw response;
              }
              
              return response.json();
          }).then(response => {

            var pieces=[];
            if (response.city) pieces.push(response.city);
            
            if (response.region_code) {
              pieces.push(response.region_code);
            } else if(response.region) {
              pieces.push(response.region);
            }
            if (response.country_code) {
              pieces.push(response.country_code);
            } else if(response.country_name) {
              pieces.push(response.country_name);
            }
            
            var address="";
            
            for (var i=0;i<pieces.length;i++) {
              if (address.length>0) address+=", ";
              address+=pieces[i];
            }

            resolve(address);
          
          }).catch((errorResponse) => {
              console.log("Error retrieving location by computer address:"+errorResponse) 
              if (errorResponse.text) {
                  errorResponse.text().then( errorMessage => {
                      reject(errorMessage);
                  })
              } else {
                  reject("An error occurred retrieving the data");
              }  
          });
        });
      }
    }
}());